/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_Save_ErrorInputs */

const vi_einvoice_buyer_save_error = /** @type {(inputs: Einvoice_Buyer_Save_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa lưu được thông tin và tạo lại PDF. Vui lòng thử lại.`)
};

/**

* @param {Einvoice_Buyer_Save_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_save_error = /** @type {((inputs?: Einvoice_Buyer_Save_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_Save_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_save_error(inputs)
});